let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7dNJ4")).then(() => parcelRequire('9rMVR'));